const GenRandomId = (length) => {
  return Math.random().toString(36).replace(/[^a-z]+/g, "").slice(0, length || 5);
};
export {
  GenRandomId as G
};
//# sourceMappingURL=GenRandomId-CMooMQt0.mjs.map
